import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Button, Row, Col, Label, Input, Form } from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";

// Crear una Solicitud de Pago. Se clasifica el destino (Proveedor / Gasto / Traspaso).
// El movimiento real NO se crea aquí: la solicitud nace en estado "Solicitada" y sólo
// al Autorizar + Ejecutar (desde el listado) se genera el pago/gasto/traspaso.
function SolicitudesPagoCreate() {
  const { user } = useContext(AuthContext);
  const URL_SOLICITUDES_PAGO = process.env.REACT_APP_URL_SOLICITUDES_PAGO;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_CONCEPTOS_PAGO = process.env.REACT_APP_URL_CONCEPTOS_PAGO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const hoy = moment(new Date()).format("YYYY-MM-DD");

  const [fecha, setFecha] = useState(hoy);
  const [clasificacion, setClasificacion] = useState("Proveedor");
  const [bancos, setBancos] = useState([]);
  const [selectedBancoDestino, setSelectedBancoDestino] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  // ODC / Embarque / Concepto (solo para pago a proveedor)
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOC, setSelectedOC] = useState("");
  const [embarques, setEmbarques] = useState([]);
  const [selectedEmbarque, setSelectedEmbarque] = useState("");
  const [conceptosPago, setConceptosPago] = useState([]);
  const [selectedConceptoPago, setSelectedConceptoPago] = useState("");
  const [concepto, setConcepto] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [monto, setMonto] = useState(0);
  const [moneda, setMoneda] = useState("MXN");
  const [tipoCambio, setTipoCambio] = useState(1);
  const [notas, setNotas] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  // Saldo de la OC y del embarque elegidos (para no pagar de mas ni pedir dos veces)
  const [saldoInfo, setSaldoInfo] = useState({});
  const [cargandoSaldo, setCargandoSaldo] = useState(false);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios
      .get(URL_BANCOS, { headers })
      .then((r) => setBancos((r.data || []).filter((b) => b.is_active !== "No")))
      .catch((e) => console.log(e));
    axios
      .get(URL_PROVEEDORES, { headers })
      .then((r) => setProveedores(r.data || []))
      .catch((e) => console.log(e));
    axios
      .get(URL_CATEGORIAS, { headers })
      .then((r) => setCategorias(r.data || []))
      .catch((e) => console.log(e));
    axios
      .get(URL_CONCEPTOS_PAGO, { headers })
      .then((r) =>
        setConceptosPago((r.data || []).filter((c) => c.is_active === "Si"))
      )
      .catch((e) => console.log(e));
  }, []);

  // Al elegir proveedor: cargar sus órdenes de compra
  useEffect(() => {
    setSelectedOC("");
    setSelectedEmbarque("");
    setEmbarques([]);
    if (!selectedProveedor) {
      setOrdenesCompra([]);
      return;
    }
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((r) =>
        setOrdenesCompra(
          (r.data || []).filter(
            (o) =>
              o.proveedores?.[0]?._id === selectedProveedor &&
              o.is_active === "Si"
          )
        )
      )
      .catch((e) => console.log(e));
  }, [selectedProveedor]);

  // Sólo los embarques que incluyen artículos de la OC seleccionada
  useEffect(() => {
    setSelectedEmbarque("");
    if (!selectedOC) {
      setEmbarques([]);
      return;
    }
    axios
      .get(`${URL_ARTICULOS_EMBARQUES}PorOC/${selectedOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((r) =>
        setEmbarques((r.data || []).filter((e) => e && e.is_active === "Si"))
      )
      .catch((e) => console.log(e));
  }, [selectedOC]);

  useEffect(() => {
    setSaldoInfo({});
    if (!selectedOC && !selectedEmbarque) return;
    const params = new URLSearchParams();
    if (selectedOC) params.set("oc", selectedOC);
    if (selectedEmbarque) params.set("embarque", selectedEmbarque);
    if (selectedProveedor) params.set("proveedor", selectedProveedor);
    setCargandoSaldo(true);
    axios
      .get(`${URL_SOLICITUDES_PAGO}Saldo?${params.toString()}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setSaldoInfo(r.data || {}))
      .catch(() => setSaldoInfo({}))
      .finally(() => setCargandoSaldo(false));
  }, [selectedOC, selectedEmbarque, selectedProveedor]);

  const dinero = (n) =>
    "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0);

  function usaSaldo(monto) {
    setMonto(Number(monto) || 0);
    setMoneda("USD");
  }

  // D06/D07 (checklist 21 OCT): anticipo de una OC
  const ocElegida = ordenesCompra.find((o) => o._id === selectedOC);
  const conceptoElegido = conceptosPago.find((c) => c._id === selectedConceptoPago);
  const esAnticipo =
    clasificacion === "Proveedor" &&
    /anticip/i.test(`${(conceptoElegido && conceptoElegido.concepto) || ""} ${concepto}`);
  const proveedorElegido = proveedores.find((p) => p._id === selectedProveedor);
  const tieneConstancia = !!(
    proveedorElegido && (proveedorElegido.archivos || []).some((a) => a.tipo === "Constancia fiscal")
  );
  const faltaConstancia = esAnticipo && !!proveedorElegido && !tieneConstancia;
  const pctAnticipo = Number((ocElegida && ocElegida.porcentajeAnticipo) || 0);
  const montoSugerido =
    esAnticipo && ocElegida && pctAnticipo > 0
      ? Math.round(Number(ocElegida.total_general || 0) * pctAnticipo) / 100
      : 0;

  // Monto y moneda predeterminados: total de la OC x % de anticipo, en la moneda de la OC.
  // Se pueden cambiar a mano despues.
  useEffect(() => {
    if (!montoSugerido) return;
    setMonto(montoSugerido);
    if (ocElegida && ocElegida.moneda) setMoneda(ocElegida.moneda);
    if (ocElegida && ocElegida.moneda && ocElegida.moneda !== "MXN" && Number(tipoCambio) === 1) setTipoCambio("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [montoSugerido, selectedOC]);

  const guardar = (event) => {
    event.preventDefault();
    if (faltaConstancia) {
      Swal.fire({
        icon: "error",
        title: "Falta la constancia fiscal del proveedor",
        text: "No se puede pedir un anticipo hasta que el proveedor tenga cargada su constancia fiscal (o su equivalente internacional) en Proveedores.",
      });
      return;
    }
    if (Number(monto) <= 0) {
      Swal.fire({ icon: "error", title: "Captura un monto" });
      return;
    }
    if (clasificacion === "Proveedor" && !selectedProveedor) {
      Swal.fire({ icon: "error", title: "Selecciona el proveedor" });
      return;
    }
    if (clasificacion === "Traspaso" && !selectedBancoDestino) {
      Swal.fire({ icon: "error", title: "Selecciona el banco destino" });
      return;
    }

    setValidaBoton(false);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios
      .post(
        URL_SOLICITUDES_PAGO,
        {
          fecha,
          clasificacion,
          // El banco origen se elige al EJECUTAR (tesorería), no aquí
          bancoDestino:
            clasificacion === "Traspaso" ? selectedBancoDestino : null,
          proveedores:
            clasificacion === "Proveedor" ? selectedProveedor : null,
          ordenesCompra:
            clasificacion === "Proveedor" ? selectedOC || null : null,
          embarques:
            clasificacion === "Proveedor" ? selectedEmbarque || null : null,
          conceptosPago:
            clasificacion === "Proveedor" ? selectedConceptoPago || null : null,
          categorias: clasificacion === "Gasto" ? selectedCategoria || null : null,
          concepto,
          descripcion,
          monto: Number(monto) || 0,
          moneda,
          tipoCambio: Number(tipoCambio) || 1,
          notas,
        },
        { headers }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Solicitud de Pago",
            detalle: `${clasificacion} / ${concepto} / ${monto} ${moneda}`,
            user: user.id,
          },
          { headers }
        );
        Swal.fire("Good job!", "Solicitud creada", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "No se pudo crear la solicitud",
          text: error?.response?.data?.message || (typeof error?.response?.data === "string" ? error.response.data : "Something went wrong!"),
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.bancos ? (
        <div className="card container col-sm-9">
          <h3 align="center">Nueva Solicitud de Pago</h3>
          <Form onSubmit={guardar}>
            <Row>
              <Col md={6}>
                <Label className="mr-sm-2">Fecha</Label>
                <Input
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Label className="mr-sm-2">Clasificación (destino)</Label>
                <Input
                  type="select"
                  value={clasificacion}
                  onChange={(e) => setClasificacion(e.target.value)}
                >
                  <option value="Proveedor">Proveedor / Producto</option>
                  <option value="Gasto">Gasto Operativo</option>
                  <option value="Traspaso">Traspaso Interno</option>
                </Input>
              </Col>
            </Row>

            {/* Campo condicional según clasificación */}
            <Row className="mt-2">
              {clasificacion === "Proveedor" ? (
                <Col md={4}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Input
                    type="select"
                    value={selectedProveedor}
                    onChange={(e) => setSelectedProveedor(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {proveedores
                      .sort((a, b) =>
                        (a.nombre_comercial || "") > (b.nombre_comercial || "")
                          ? 1
                          : -1
                      )
                      .map((p) => (
                        <option value={p._id}>
                          {p.codigo} - {p.nombre_comercial}
                        </option>
                      ))}
                  </Input>
                </Col>
              ) : null}
              {clasificacion === "Proveedor" ? (
                <>
                  <Col md={2}>
                    <Label className="mr-sm-2">ODC</Label>
                    <Input
                      type="select"
                      value={selectedOC}
                      disabled={!selectedProveedor}
                      onChange={(e) => setSelectedOC(e.target.value)}
                    >
                      <option value="">Sin OC</option>
                      {ordenesCompra
                        .sort((a, b) =>
                          a.idOrdenCompra < b.idOrdenCompra ? 1 : -1
                        )
                        .map((o) => (
                          <option value={o._id}>OC {o.idOrdenCompra}</option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Embarque</Label>
                    <Input
                      type="select"
                      value={selectedEmbarque}
                      disabled={!selectedOC}
                      onChange={(e) => setSelectedEmbarque(e.target.value)}
                    >
                      <option value="">Sin Embarque</option>
                      {embarques
                        .sort((a, b) =>
                          a.idEmbarques < b.idEmbarques ? 1 : -1
                        )
                        .map((em) => (
                          <option value={em._id}>
                            EMB #{em.idEmbarques} {em.contenedor}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Concepto de Pago</Label>
                    <Input
                      type="select"
                      value={selectedConceptoPago}
                      onChange={(e) => setSelectedConceptoPago(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {conceptosPago
                        .sort((a, b) => (a.concepto > b.concepto ? 1 : -1))
                        .map((c) => (
                          <option value={c._id}>{c.concepto}</option>
                        ))}
                    </Input>
                  </Col>
                </>
              ) : null}
              {clasificacion === "Gasto" ? (
                <Col md={4}>
                  <Label className="mr-sm-2">Categoría</Label>
                  <Input
                    type="select"
                    value={selectedCategoria}
                    onChange={(e) => setSelectedCategoria(e.target.value)}
                  >
                    <option value="">Sin categoría</option>
                    {categorias
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((c) => (
                        <option value={c._id}>{c.name}</option>
                      ))}
                  </Input>
                </Col>
              ) : null}
              {clasificacion === "Traspaso" ? (
                <Col md={4}>
                  <Label className="mr-sm-2">Banco Destino</Label>
                  <Input
                    type="select"
                    value={selectedBancoDestino}
                    onChange={(e) => setSelectedBancoDestino(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((b) => (
                        <option value={b._id}>
                          {b.banco} {b.cuenta} ({b.moneda})
                        </option>
                      ))}
                  </Input>
                </Col>
              ) : null}
              <Col md={4}>
                <Label className="mr-sm-2">Concepto</Label>
                <Input
                  type="text"
                  value={concepto}
                  onChange={(e) => setConcepto(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Descripción</Label>
                <Input
                  type="text"
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                />
              </Col>
            </Row>

            {clasificacion === "Proveedor" && (selectedOC || selectedEmbarque) ? (
              <div
                style={{
                  marginTop: 10,
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 13,
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                }}
              >
                {cargandoSaldo ? (
                  <span style={{ color: "#64748b" }}>Calculando saldo...</span>
                ) : (
                  <>
                    {saldoInfo.embarque ? (
                      <div style={{ marginBottom: saldoInfo.oc ? 6 : 0 }}>
                        <b>
                          Embarque #{saldoInfo.embarque.numero} {saldoInfo.embarque.contenedor}
                        </b>
                        {saldoInfo.embarque.sinLineas ? (
                          <span style={{ color: "#b45309" }}> · no tiene articulos cargados</span>
                        ) : (
                          <>
                            {" "}
                            · {saldoInfo.embarque.estimado ? "Valor a precio de OC" : "Total"}{" "}
                            {dinero(saldoInfo.embarque.total)} {saldoInfo.embarque.moneda} · Pagado{" "}
                            {dinero(saldoInfo.embarque.pagado)} USD ·{" "}
                            {saldoInfo.embarque.saldo === null ? (
                              <span style={{ color: "#64748b" }}>
                                en {saldoInfo.embarque.moneda}: el saldo no se resta directo
                              </span>
                            ) : (
                              <>
                                <b style={{ color: saldoInfo.embarque.saldo > 0 ? "#b91c1c" : "#15803d" }}>
                                  Saldo {saldoInfo.embarque.estimado ? "estimado " : ""}
                                  {dinero(saldoInfo.embarque.saldo)} USD
                                </b>
                                {saldoInfo.embarque.saldo > 0 ? (
                                  <Button
                                    size="sm"
                                    color="link"
                                    title="Poner el saldo del embarque como monto (en USD)"
                                    onClick={() => usaSaldo(saldoInfo.embarque.saldo)}
                                  >
                                    Usar saldo
                                  </Button>
                                ) : null}
                              </>
                            )}
                            {saldoInfo.embarque.estimado ? (
                              <div style={{ fontSize: 11, color: "#64748b" }}>
                                Embarque sin costear: lo embarcado a precio de la OC menos los pagos ligados a este embarque
                                {saldoInfo.embarque.topeOC
                                  ? `, limitado a lo que le falta a la OC ${saldoInfo.embarque.topeOC.numero} (ya tiene pagos registrados sin embarque).`
                                  : "."}
                              </div>
                            ) : null}
                          </>
                        )}
                        {saldoInfo.embarque.solicitudesEnTramite ? (
                          <div style={{ fontSize: 12, color: "#b45309" }}>
                            Ya hay {saldoInfo.embarque.solicitudesEnTramite} solicitud
                            {saldoInfo.embarque.solicitudesEnTramite > 1 ? "es" : ""} sin ejecutar de este embarque por{" "}
                            {dinero(saldoInfo.embarque.enTramite)} USD
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {saldoInfo.oc ? (
                      <div>
                        <b>OC {saldoInfo.oc.numero}</b> · Total {dinero(saldoInfo.oc.total)} {saldoInfo.oc.moneda} · Pagado{" "}
                        {dinero(saldoInfo.oc.pagado)} USD
                        {saldoInfo.oc.pagos ? ` (${saldoInfo.oc.pagos} pago${saldoInfo.oc.pagos > 1 ? "s" : ""})` : ""} ·{" "}
                        {saldoInfo.oc.saldo === null ? (
                          <span style={{ color: "#64748b" }}>
                            la OC esta en {saldoInfo.oc.moneda} y los pagos en USD: el saldo no se resta directo
                          </span>
                        ) : (
                          <>
                            <b style={{ color: saldoInfo.oc.saldo > 0 ? "#b91c1c" : "#15803d" }}>
                              Saldo {dinero(saldoInfo.oc.saldo)} USD
                            </b>
                            {!saldoInfo.embarque && saldoInfo.oc.saldo > 0 ? (
                              <Button
                                size="sm"
                                color="link"
                                title="Poner el saldo de la orden como monto (en USD)"
                                onClick={() => usaSaldo(saldoInfo.oc.saldo)}
                              >
                                Usar saldo
                              </Button>
                            ) : null}
                          </>
                        )}
                        {saldoInfo.oc.enTramite ? (
                          <div style={{ fontSize: 12, color: "#b45309" }}>
                            En tramite (solicitudes sin ejecutar o pagos simulados): {dinero(saldoInfo.oc.enTramite)} USD
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            ) : null}
            {esAnticipo && ocElegida ? (
              <div
                style={{
                  marginTop: 10,
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 13,
                  background: pctAnticipo > 0 ? "#eff6ff" : "#fffbeb",
                  border: `1px solid ${pctAnticipo > 0 ? "#bfdbfe" : "#fde68a"}`,
                }}
              >
                {pctAnticipo > 0 ? (
                  <>
                    Anticipo de la OC {ocElegida.idOrdenCompra}: <b>{pctAnticipo}%</b> de{" "}
                    {"$" + new Intl.NumberFormat("en-US").format(ocElegida.total_general || 0)} {ocElegida.moneda} ={" "}
                    <b>
                      {"$" + new Intl.NumberFormat("en-US").format(montoSugerido)} {ocElegida.moneda}
                    </b>
                    {Number(monto) !== montoSugerido ? (
                      <Button
                        size="sm"
                        color="link"
                        title="Volver a poner el monto calculado con el % de anticipo"
                        onClick={() => {
                          setMonto(montoSugerido);
                          if (ocElegida.moneda) setMoneda(ocElegida.moneda);
                        }}
                      >
                        Usar este monto
                      </Button>
                    ) : null}
                  </>
                ) : (
                  <>La OC {ocElegida.idOrdenCompra} no tiene % de anticipo capturado; captura el monto a mano o agregalo al editar la OC.</>
                )}
              </div>
            ) : null}
            {faltaConstancia ? (
              <div
                style={{
                  marginTop: 10,
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 13,
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  color: "#991b1b",
                }}
              >
                <i class="fas fa-ban"></i> <b>{proveedorElegido.nombre_comercial}</b> no tiene constancia fiscal
                cargada. No se puede pedir el anticipo hasta subirla en Proveedores (clip <i class="fas fa-paperclip"></i>).
              </div>
            ) : null}

            <Row className="mt-2">
              <Col md={3}>
                <Label className="mr-sm-2">Monto</Label>
                <CurrencyInput
                  intlConfig={{ locale: "en-US", currency: "USD" }}
                  prefix="$"
                  defaultValue={0}
                  decimalsLimit={2}
                  value={monto}
                  className="form-control"
                  onValueChange={(value) => setMonto(value || 0)}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Moneda</Label>
                <Input
                  type="select"
                  value={moneda}
                  onChange={(e) => setMoneda(e.target.value)}
                >
                  <option value="MXN">MXN</option>
                  <option value="USD">USD</option>
                  {/* La OC puede estar en otra moneda (CNY, EUR) */}
                  {moneda && moneda !== "MXN" && moneda !== "USD" ? <option value={moneda}>{moneda}</option> : null}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Tipo de Cambio</Label>
                <Input
                  type="number"
                  step="any"
                  value={tipoCambio}
                  onChange={(e) => setTipoCambio(e.target.value)}
                />
              </Col>
              <Col md={5}>
                <Label className="mr-sm-2">Notas</Label>
                <Input
                  type="text"
                  value={notas}
                  onChange={(e) => setNotas(e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Crear Solicitud
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Crear Solicitud
                  </Button>
                )}{" "}
                <Button className="btn btn-danger" href="/SolicitudesPago">
                  Regresar
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default SolicitudesPagoCreate;
